import './team.css';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const members = [
  {
    name: 'Hossein Marjani',
    title: 'Software Automation Engineer',
    photo: '/team/hossein-marjani.png',
    url: 'https://www.linkedin.com/in/hossein-marjani-9136a189/',
  },
  {
    name: 'Mehdi Jafari',
    title: 'Automation ROI Lead',
    photo: '/team/mehdi-jafari.png',
    url: 'https://www.linkedin.com/in/mehdi-jafari-csp/',
  },
  {
    name: 'Alireza Ansari',
    title: 'Forward Deployed Engineer, MCP Integration',
    photo: '/team/alireza-ansari.png',
    url: 'https://www.linkedin.com/in/mr-alireza-ansari/',
  },
  {
    name: 'Mehdi Zoghiniya',
    title: 'Forward Deployed Engineer, Business Automation',
    photo: '/team/mehdi-zoghiniya.png',
    url: 'https://www.linkedin.com/in/mehdizoghinia/',
  },
];

const logos = [
  { name: 'Centech', url: '/logo/Centech1.png' },
  { name: 'Fintech Station', url: '/logo/Fintech1.jpg' },
  { name: 'Finance Montréal', url: '/logo/FinanceMtl1.png' },
  { name: 'Fintech Cadence', url: '/logo/FintechCadance.png' },
  { name: 'Cycle Momentum', url: '/logo/cycleMomentum1.png' },
  { name: 'Esplanade Québec', url: '/logo/esplanade3.jpg' },
];

const TeamSection = () => {
  const { t } = useTranslation();
  const trackRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animationFrame: number;
    let lastTime: number | null = null;
    const speed = 40; // pixels per second
    let offset = 0;
    let singleWidth = 0;

    const loop = (timestamp: number) => {
      if (lastTime == null) {
        lastTime = timestamp;
      } else {
        const delta = (timestamp - lastTime) / 1000; // seconds since last frame
        lastTime = timestamp;

        // Measure width of ONE logo set (first child) once it's rendered
        if (singleWidth === 0) {
          const firstSet = track.firstElementChild as HTMLElement | null;
          if (firstSet) {
            singleWidth = firstSet.getBoundingClientRect().width;
          }
        }

        if (singleWidth > 0) {
          offset -= speed * delta;

          // Wrap offset into [-singleWidth, 0) range for seamless loop
          offset = ((offset % singleWidth) + singleWidth) - singleWidth;

          track.style.transform = `translate3d(${offset}px, 0, 0)`;
        }
      }

      animationFrame = requestAnimationFrame(loop);
    };

    animationFrame = requestAnimationFrame(loop);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <section className="team-section" id="team">
      <div className="team-container">
        <p className="team-eyebrow">{t('team_eyebrow')}</p>
        <h2>{t('team-title')}</h2>
        <p className="team-intro">{t('team-intro')}</p>
        <ul className="team-grid">
          {members.map((member) => (
            <li className="team-card" key={member.name}>
              <a href={member.url} target="_blank" rel="noopener noreferrer">
                <img src={member.photo} alt="" />
                <span className="team-card-name">{member.name}</span>
                {member.title ? <span className="team-card-title">{member.title}</span> : null}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="team-ecosystem">
        <h3 className="team-ecosystem-title">
          {t('team_ecosystem_title')}
        </h3>
        <div className="ecosystem-logo-strip">
          <div className="ecosystem-logo-track" ref={trackRef}>
            <div className="ecosystem-logo-set">
              {logos.map((logo, index) => (
                <div className="ecosystem-logo" key={`a-${index}`}>
                  <img src={logo.url} alt={logo.name} />
                </div>
              ))}
            </div>
            <div className="ecosystem-logo-set">
              {logos.map((logo, index) => (
                <div className="ecosystem-logo" key={`b-${index}`}>
                  <img src={logo.url} alt={logo.name} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
